import React from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  const grades = [{
    color: 'bg-orange-500',
    title: '1.º GRADO',
    desc: 'Mi entorno, familia, comunidad, normas básicas y primeras nociones de espacio.'
  }, {
    color: 'bg-blue-500',
    title: '2.º GRADO',
    desc: 'Instituciones, barrio, localidad, mapas simples y efemérides fundamentales.'
  }, {
    color: 'bg-green-500',
    title: '3.º GRADO',
    desc: 'Provincias argentinas, actividades económicas, líneas de tiempo y hechos históricos clave.'
  }, {
    color: 'bg-yellow-500',
    title: '4.º GRADO',
    desc: 'Organización política, regiones del país, recursos naturales y procesos históricos.'
  }, {
    color: 'bg-red-500',
    title: '5.º GRADO',
    desc: 'Historia argentina, organización del Estado, ciudadanía y análisis de problemáticas sociales.'
  }, {
    color: 'bg-purple-500',
    title: '6.º GRADO',
    desc: 'Procesos históricos más complejos, América Latina, globalización y pensamiento crítico.'
  }];
  return <section className="bg-white py-16 px-4 md:px-8" data-id="element-179">
      <div className="max-w-4xl mx-auto" data-id="element-180">
        <div className="text-center mb-12" data-id="element-181">
          <h3 className="text-xl font-bold text-green-600 uppercase tracking-widest mb-2" data-id="element-182">
            La Solución
          </h3>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6" data-id="element-183">
            MEGA PACK CIENCIAS SOCIALES LISTA
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto mb-8" data-id="element-184">
            Sistema completo de clases, actividades, proyectos y evaluaciones ya
            probadas en aula primaria.
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-lg font-bold text-gray-800" data-id="element-185">
            <span className="flex items-center gap-2" data-id="element-186">
              <Check className="text-green-600" data-id="element-187" /> Listo
            </span>
            <span className="flex items-center gap-2" data-id="element-188">
              <Check className="text-green-600" data-id="element-189" /> Probado
            </span>
            <span className="flex items-center gap-2" data-id="element-190">
              <Check className="text-green-600" data-id="element-191" /> Organizado
            </span>
            <span className="flex items-center gap-2" data-id="element-192">
              <Check className="text-green-600" data-id="element-193" /> Usable
            </span>
          </div>
        </div>

        <div className="bg-gray-50 p-6 md:p-10 rounded-2xl shadow-sm border border-gray-100" data-id="element-194">
          <h3 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-195">
            📘 ¿QUÉ INCLUYE EL MEGA PACK CIENCIAS SOCIALES LISTA?
          </h3>

          <div className="space-y-6" data-id="element-196">
            {grades.map((grade, idx) => <div key={idx} className="flex items-start gap-4" data-id="element-197">
                <span className={`flex-shrink-0 w-4 h-4 mt-1.5 rounded-full ${grade.color}`} data-id="element-198" />
                <p className="text-lg text-gray-800" data-id="element-199">
                  <span className="font-bold" data-id="element-200">{grade.title}</span> {grade.desc}
                </p>
              </div>)}
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-201">
            {['Planificación anual lista', 'Evaluaciones y seguimiento', 'Secuencias y proyectos aplicados', 'Material editable y listo para usar'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-202">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-203">
                  <Check className="w-5 h-5 text-green-600" data-id="element-204" />
                </div>
                <span className="font-bold text-gray-800" data-id="element-205">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}